(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["main-cart-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {
              this.innerHTML = innerHTML.innerHTML;
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const innerHTML = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('product-recommendations');
            if ( innerHTML && innerHTML.querySelectorAll('.product-item').length > 0 ) {

              var $html = $('<div>'+innerHTML.innerHTML+'</div>');

              let color = currentColor;
              let defaultColor = "black";

              $html.find('.image-has-colors').each(function(index, el){
                let srcAttrDefault = "data-variant-src-" + defaultColor;
                let srcSetAttrDefault = "data-variant-srcset-" + defaultColor;
                let srcValDefault = $(this).attr(srcAttrDefault);
                let srcSetValDefault = $(this).attr(srcSetAttrDefault);

                let srcAttr = "data-variant-src-" + color.toLowerCase();
                let srcSetAttr = "data-variant-srcset-" + color.toLowerCase();
                let srcVal = $(this).attr(srcAttr);
                let srcSetVal = $(this).attr(srcSetAttr);

                if (typeof srcVal !== 'undefined') {
                  $(this).attr('src',srcVal);
                  $(this).attr('srcset',srcSetVal);
                  $(this).parent('.product__image-zoom').attr('data-image',srcVal.replace('&width=640'));
                } else {
                  $(this).attr('src',srcValDefault);
                  $(this).attr('srcset',srcSetValDefault);
                  $(this).parent('.product__image-zoom').attr('data-image',srcValDefault.replace('&width=640'));
                }
              })

              $html.find('.link-has-variants').each(function(){
                let idAttrDefault = "data-variant-id-" + defaultColor;
                let idValDefault = $(this).attr(idAttrDefault);

                let idAttr = "data-variant-id-" + color.toLowerCase();
                let idVal = $(this).attr(idAttr);

                let link = new URL($(this).attr('href'), window.location.origin);

                if (typeof idVal !== 'undefined') {
                  link.searchParams.set('variant', idVal);
                } else {
                  link.searchParams.set('variant', idValDefault);
                }
                $(this).attr('href', link.toString());
              })

              this.innerHTML = $html.html();
              window.preloadImages(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
      })();
